import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONFIG } from 'src/app/config';

@Component({
  selector: 'app-sidenav-header',
  templateUrl: './sidenav-header.component.html',
  styleUrls: ['./sidenav-header.component.scss']
})
export class SidenavHeaderComponent implements OnInit {

  @Input() sidenavMobile: boolean;
  @Input() sidenavOpened: boolean;
  @Input() sidenavLocked: boolean;
  @Input() navbarHeight: number;
  @Output('sidenavLockedEmitter') sidenavLockedEmitter = new EventEmitter<boolean>();

  constructor(private router: Router) { }

  ngOnInit() { }

  private gotoURL() {
    if (APP_CONFIG.logoRedirect.externalURL) {
      window.location.href = APP_CONFIG.logoRedirect.url;
    } else {
      this.router.navigate(['' + APP_CONFIG.logoRedirect.url + '']);
    }
  }
  private sidenavLock(event) {
    this.sidenavLockedEmitter.emit(!this.sidenavLocked);
  }
}
